import { render, staticRenderFns } from "./ibo.vue?vue&type=template&id=f0fe16a8&scoped=true&"
import script from "./ibo.vue?vue&type=script&lang=js&"
export * from "./ibo.vue?vue&type=script&lang=js&"
import style0 from "./ibo.vue?vue&type=style&index=0&id=f0fe16a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fe16a8",
  null
  
)

export default component.exports